import { createRouter, createWebHashHistory } from 'vue-router';
import UsedLoginIndex from '@/pages/LoginIndex.vue';
import UsedModuleTemplateIndex from '@/pages/ModuleTemplateIndex.vue';
import UsedHomeIndex from '@/pages/HomeIndex.vue';
import UsedArticleIndex from '@/pages/ArticleIndex.vue';
import encryptHandler from '@/utils/encrypt';
const routes = [
  {
    path: '/',
    name: 'UsedLoginIndex',
    component: UsedLoginIndex,
    meta: {
      title: 'Login',
      layout: 'General',
      requiresAuth: false
    }
  },
  {
    path: '/portal/home/:id(.*)',
    name: 'HomeIndex',
    component: UsedHomeIndex,
    meta: {
      title: 'Gazette',
      layout: 'Account',
      requiresAuth: true
    }
  },
  {
    path: '/portal/home/article/:id(.*)',
    name: 'AticleIndex',
    component: UsedArticleIndex,
    meta: {
      title: 'Gazette',
      layout: 'Account',
      requiresAuth: true
    }
  },
  {
    path: '/portal/:module/:section/:id(.*)',
    name: 'ModuleTemplate',
    component: UsedModuleTemplateIndex,
    meta: {
      title: 'Gazette',
      layout: 'Account',
      requiresAuth: true
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});
router.beforeEach(async (to, from, next) => {
  const { encryptFile } = encryptHandler();
  document.title = `IWC Gazette`;
  const token = localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN);
  let isAuthenticate = token ? true : false;
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticate) {
      next({ path: '/' });
    } else {
      next();
    }
  } else {
    if (to.name === 'UsedLoginIndex' && isAuthenticate) {
      next({ path: `/portal/home/${encryptFile('iwc')}` });
    } else {
      next();
    }
  }
});
export default router;
